import React from 'react';
import Configurator from './Configurator.jsx';
import styles from './PigtailConfigurator.styl';
import stylesPatchcord from './PatchcordConfigurator.styl';

/**
 * Конфигуратор pigtail
 */
class PigtailConfigurator extends Configurator
{
	constructor(props) {
		super(props);
		this.onSwitchConfigurator = this.onSwitchConfigurator.bind(this);
	}

	getType() {
		return 'pigtail';
	}
	// из-за того что на itk сервере старый php переводим временно конфигуратор на iek сервер
	// после того как на itk сервере обновят php, просто убрать этот метод и будет работать родительский getApiUrl()
	getApiUrl() {
		return 'https://cfg.iek.ru/api/iek-proxy/products/configurators/iekcfg/itkcfg.php';
	}

	onSwitchConfigurator() {
		if (this.props.onSwitchConfigurator) {
			this.props.onSwitchConfigurator();
		}
	}

	getCustomElements() {
		let elements = [];

		elements.push(
			<label className={stylesPatchcord.confTypePatchcord} key="patchcord">
				<span className={stylesPatchcord.confTypeTitle}>Патч-корд</span>
				<input className={stylesPatchcord.confTypeControl} name="itkcfg_filter_conf_type" type="radio" defaultChecked={false} onChange={this.onSwitchConfigurator} />
			</label>
		);

		elements.push(
			<label className={stylesPatchcord.confTypePigtail} key="pigtail">
				<span className={stylesPatchcord.confTypeTitle}>Пигтейл</span>
				<input className={stylesPatchcord.confTypeControl} name="itkcfg_filter_conf_type" type="radio" defaultChecked={true} />
			</label>
		);

		return elements;
	}

	getCustomStyles() {
		return styles;
	}
}

export default PigtailConfigurator;



// WEBPACK FOOTER //
// ./src/react/PigtailConfigurator.jsx